package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LipsW500Rounded: ImageVector
    get() {
        if (_lipsW500Rounded != null) {
            return _lipsW500Rounded!!
        }
        _lipsW500Rounded = Builder(name = "LipsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(481.0f, 475.7f)
                quadToRelative(88.37f, 0.0f, 169.96f, -17.65f)
                quadToRelative(81.58f, -17.64f, 138.06f, -34.88f)
                lineTo(665.35f, 299.5f)
                quadToRelative(-6.72f, -6.72f, -15.3f, -10.2f)
                quadToRelative(-8.57f, -3.47f, -17.53f, -3.47f)
                quadToRelative(-6.72f, 0.0f, -12.93f, 1.74f)
                quadToRelative(-6.22f, 1.73f, -11.94f, 5.97f)
                lineToRelative(-101.78f, 67.7f)
                quadToRelative(-11.44f, 7.96f, -25.37f, 7.96f)
                quadToRelative(-13.93f, 0.0f, -25.37f, -7.96f)
                lineToRelative(-101.78f, -67.46f)
                quadToRelative(-5.72f, -4.24f, -11.94f, -5.98f)
                quadToRelative(-6.21f, -1.73f, -12.93f, -1.73f)
                quadToRelative(-8.96f, 0.0f, -17.41f, 3.35f)
                quadToRelative(-8.46f, 3.36f, -15.18f, 10.08f)
                lineTo(172.98f, 423.17f)
                quadToRelative(55.72f, 17.24f, 137.8f, 34.88f)
                quadTo(392.87f, 475.7f, 481.0f, 475.7f)
                close()
                moveTo(457.59f, 678.8f)
                horizontalLineToRelative(45.3f)
                quadToRelative(105.85f, 0.0f, 172.68f, -44.48f)
                quadToRelative(66.82f, -44.49f, 120.1f, -120.1f)
                quadToRelative(-59.76f, 17.76f, -142.89f, 34.16f)
                quadToRelative(-83.13f, 16.4f, -172.54f, 16.4f)
                quadToRelative(-89.89f, 0.0f, -172.76f, -16.78f)
                quadToRelative(-82.87f, -16.78f, -142.87f, -33.78f)
                quadToRelative(52.8f, 74.65f, 120.21f, 119.62f)
                quadToRelative(67.4f, 44.96f, 172.77f, 44.96f)
                close()
                moveTo(502.89f, 768.13f)
                horizontalLineToRelative(-45.54f)
                quadToRelative(-136.68f, 0.0f, -247.45f, -77.53f)
                quadTo(99.13f, 613.07f, 48.26f, 485.91f)
                quadToRelative(-9.43f, -22.39f, -3.22f, -45.76f)
                quadToRelative(6.22f, -23.37f, 23.37f, -40.28f)
                lineToRelative(163.07f, -162.35f)
                quadToRelative(19.15f, -19.15f, 43.76f, -30.37f)
                quadToRelative(24.61f, -11.22f, 51.72f, -11.22f)
                quadToRelative(20.39f, 0.0f, 40.16f, 6.86f)
                quadToRelative(19.77f, 6.86f, 36.68f, 18.3f)
                lineToRelative(76.2f, 50.54f)
                lineToRelative(76.43f, -50.54f)
                quadToRelative(16.92f, -11.44f, 36.57f, -18.3f)
                quadToRelative(19.65f, -6.86f, 40.04f, -6.86f)
                quadToRelative(27.11f, 0.0f, 51.72f, 11.34f)
                reflectiveQuadToRelative(43.76f, 30.49f)
                lineToRelative(163.07f, 162.11f)
                quadToRelative(17.15f, 16.91f, 23.25f, 40.28f)
                quadToRelative(6.09f, 23.37f, -3.1f, 45.76f)
                quadToRelative(-49.63f, 127.16f, -160.9f, 204.69f)
                quadToRelative(-111.27f, 77.53f, -247.95f, 77.53f)
                close()
            }
        }
        .build()
        return _lipsW500Rounded!!
    }

private var _lipsW500Rounded: ImageVector? = null
